import { Partial } from '@40seas/entities/common';
import { AuthApplication } from './auth-application.entity';

export class UpdateAuthApplicationDto extends Partial(AuthApplication) {}
